import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Typography,
  Button,
  Grid,
  TextField,
  Box,
  RadioGroup,
  Paper,
  FormControlLabel, Radio, 
  Divider
} from '@mui/material';
import Footer from '../components/SFooter';
import Header from '../components/Header';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import addressService from '../service/addressService'; 
import orderService from '../service/orderService';
import deliveryService from '../service/deliveryService';
import cartService from '../service/cartService';

const Checkout = () => {
  const navigate = useNavigate(); // initialize navigate
  const { t } = useTranslation();
  const { cart, setCart } = useCart();
  //const [shippingCost, setShippingCost] = useState(50);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
   const [selectedShippingCountry, setSelectedShippingCountry] = useState(null);
   const [selectedShippingZipcode, setSelectedShippingZipcode] = useState(null);
  
  const [formData, setFormData] = useState({
    street1: "",
    street2: "",
    city: "",
    state: "",
    country: "",
    phone: "",
    email: "",
  });
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const { user } = useAuth();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = user || {};
  
  useEffect(() => {
    if (userId) {
      loadAddresses();
    }
  }, [user]);
  
    const loadAddresses = async () => {
    const res = await addressService.getUserAddresses(userId);
    setAddresses(res);
    if (res.length > 0) {
      setSelectedAddressId(res[0].addressId); // default select first address
      setSelectedShippingCountry(res[0].country);
      setSelectedShippingZipcode(res[0].postalCode);
    }
  };
  
    const handleSelectAddress = (addressId) => {
    setSelectedAddressId(addressId);
      
    const selectedAddress = addresses.find(
    (addr) => {
        // 🐛 Debugging: Log the ID from the array item and the ID you're comparing it against
      console.log(`Comparing ${addr.addressId} with ${selectedAddressId}`);
      console.log(`Are they equal?`, String(addr.addressId) === selectedAddressId);
      return String(addr.addressId) === addressId;
    }
  );

  // If an address is found, set the state variables
  if (selectedAddress) {

  //  alert(selectedAddress.country + "  P " + selectedAddress.postalCode);
    
    setSelectedShippingCountry(selectedAddress.country);
    setSelectedShippingZipcode(selectedAddress.postalCode);
  }
    

  };
  
   const handleSaveAddress = async () => {
         if(!formData.street1 || !formData.city || !formData.state || !formData.country || !formData.email || !formData.postalCode || !formData.phone){
      alert("Please fill all the details!");
      return;
    }
    formData.userId= user.userId;
     
    await addressService.saveAddress(userId, formData);
    setFormData({ street1: "",  street2: "", city: "", state: "", country: "",postalCode: "", phone: "", email: "" });
    loadAddresses();
  };


  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const calculateTotal = () => {
    return cart.reduce((sum, item) => {
      const itemTotal = item.priceAtTimeOfAdd * item.quantity;
      const discountedPrice = item.discountAtTimeOfAdd;
      return sum + (itemTotal - discountedPrice);
    }, 0);
  };

  const calculateTotalDiscount = () => {
  return cart.reduce((sum, item) => {
    if (item.discountAtTimeOfAdd > 0) {
      return sum + item.discountAtTimeOfAdd;
    }
    return sum;
  }, 0);
};
  
    const calculateTax = () => {
  return cart.reduce((sum, item) => {
    if (item.taxAtTimeOfAdd > 0) {
      return sum + item.taxAtTimeOfAdd;
    }
    return sum;
  }, 0);
};

  const GST_RATE = 0.18; // 18%
  const SHIPPING_COST = 50;

  const subtotal = calculateTotal();
  const gstAmount = subtotal * calculateTax();
  const discountFee = calculateTotalDiscount();
  const totalWithCharges = subtotal + gstAmount + SHIPPING_COST;
  const grandTotal = totalWithCharges - discountFee;

  const handlePayment = async () => {
   

  const res =   await deliveryService.checkDelivery(selectedShippingCountry,selectedShippingZipcode);
    if(res){

     const response = res.data;
      alert(response.deliverable + " Duration in Minutes " + response.durationMinutes + ", Distance " + response.distanceKm);
      if(!response.deliverable){
         alert("Not able to deliver to this address. Please contact support # 12323232 ");
          return;
      }
       
    }
    
    const cartInfo = {
    cartId: cart[0].cartId,
    userId: userId,
    shippingAddress: {
      addressId: selectedAddressId
    },
    totalAmount: subtotal,
    taxAmount: gstAmount,
     shippingCost:SHIPPING_COST,
      grandTotal: grandTotal,
      discountFee: discountFee
    };
    
    cartService.updateCartTotal(cartInfo);
    
    //selectedAddressId
    

   // alert("success"); 
   navigate('/delivery-slots');
    
   /* try {
      const orderItems = cart.map((item) => ({
        productId: item.productId || item.id,
        quantity: item.quantity || 1,
        unitPrice: item.price,
        discountApplied: item.discountPercent,
        productVariantId: item.productId //item.variants[0].variantId
      }));

      const orderPayload = {
        userId: userId, // Replace with actual logged-in user ID
        orderDate: new Date().toISOString(),
        totalAmount: parseFloat(calculateTotal()),
        taxAmount: 0,
        currencyId: 1,
        shippingCost: parseFloat(shippingCost),
        grandTotal: parseFloat(calculateItems()),
        orderStatusId: 1,
        shippingAddress: {
           addressId: selectedAddressId
        },
        items: orderItems
      };

    var response = orderService.saveOrder(orderPayload);

   if (response.status === 200 || response.status === 201) {
        const orderId = response.data.orderId;
        setCart([]);
        navigate('/payment', {
          state: {
            orderId,
            amount: calculateTotal()
          }
        });
      }
    } catch (error) {
      console.error("Order creation or payment failed", error);
      alert("Something went wrong. Please try again.");
    }*/
  };

  return (
    <>
      <Header />
      <Container>
      <Typography variant="h4">{t('checkout')}</Typography>

        {cart.length === 0 ? (
          <Typography variant="h6">{t('emptyCart')}</Typography>
        ) : (
          <>
          
            <Grid container spacing={2}>
                {/* Address Selection */}
      <Grid item xs={12} md={6}>
        <Typography variant="h5">Select Shipping Address</Typography>
        {addresses.length > 0 ? (
          <RadioGroup value={selectedAddressId} onChange={(e) => handleSelectAddress(e.target.value)}>
            {addresses.map((addr) => (
              <Paper key={addr.addressId} style={{ padding: "10px", margin: "10px 0" }}>
                <FormControlLabel
                  value={addr.addressId}
                  control={<Radio />}
                  label={`${addr.street1},${addr.street2}, ${addr.city}, ${addr.state}, ${addr.country} - ${addr.postalCode}`}
                />
                {`${addr.email}, ${addr.phone}`}
              </Paper>
            ))}
          </RadioGroup>
        ) : (
          <Typography>No saved addresses. Please add one in profile.</Typography>
        )}
      </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h5">{t('shippingAddress')}</Typography>
                <TextField
                  label="Street Line 1"
                  name="street1"
                  fullWidth
                  variant="outlined"
                  value={formData.street1}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <TextField
                  label="Street Line 2"
                  name="street2"
                  fullWidth
                  variant="outlined"
                  value={formData.street2}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <TextField
                  label="City"
                  name="city"
                  fullWidth
                  variant="outlined"
                  value={formData.city}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <TextField
                  label="State"
                  name="state"
                  fullWidth
                  variant="outlined"
                  value={formData.state}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <TextField
                  label="Country"
                  name="country"
                  fullWidth
                  variant="outlined"
                  value={formData.country}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <TextField
                  label="Postal Code"
                  name="postalCode"
                  fullWidth
                  variant="outlined"
                  value={formData.postalCode}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <TextField
                  label="Phone"
                  name="phone"
                  fullWidth
                  variant="outlined"
                  value={formData.phone}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <TextField
                  label="Email"
                  name="email"
                  fullWidth
                  variant="outlined"
                  value={formData.email}
                  onChange={handleInputChange}
                  style={{ margin: '10px 0' }}
                />
                <Button variant="contained" color="primary" onClick={handleSaveAddress}>Save Address</Button>
              </Grid>
                      
            </Grid>

            <Box mt={4}>
            <Typography variant="h6">Subtotal: ₹{subtotal ? subtotal.toFixed(2) : '0.00'}</Typography>
            <Typography variant="body1" color="error">
                You saved: ₹{calculateTotalDiscount().toFixed(2)}
            </Typography>
            <Typography variant="body1">GST (18%): ₹{gstAmount.toFixed(2)}</Typography>
            <Typography variant="body1">Shipping: ₹{SHIPPING_COST.toFixed(2)}</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="h5">Total: ₹{totalWithCharges.toFixed(2)}</Typography>
            </Box>

            <Box mt={4}>
              {paymentConfirmed ? (
                <Typography variant="h6" style={{ color: 'green' }}>
                  Payment successful! Your order is confirmed.
                </Typography>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlePayment}
               disabled={!selectedAddressId} 
                >
                  {t('confirmPayment')}
                </Button>
              )}
            </Box>
          </>
        )}
      </Container>
      <Footer />
    </>
  );
};

export default Checkout;